<template>
  <div>
    <vx-card class="relative">
      <div>
        <vs-row vs-w="12" class="mb-5">
          <vs-col vs-lg="4" vs-sm="4" vs-xs="12">
            <vs-button @click="goBack" color="primary" type="border">Back</vs-button>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
            <h3>Data Build Unmatched Accounts - {{ campaignDescription.campaign_name }}</h3>
          </vs-col>
        

      
          


          <vs-col class="right" vs-lg="4" vs-sm="4" vs-xs="12">

            <div style="float:right; margin-left: 10px;">
              <vs-button :color="acceptButtonColor" type="filled"
              @click="proceedToNextStep">Proceed</vs-button>
            </div>
            
          


              <!-- <input
              type="checkbox"
              v-model="allSelected"
              style="float:right;"
              @click="selectAll"
            /> -->
          </vs-col>
        </vs-row>
      </div>
    </vx-card>
    <progress-bar bar-color="grey" :val="uploadPercentage" :text="PLeasewait"></progress-bar>

    <vx-card class="vxtable">


     <h3>{{  'Total : ' +  this.all_total}}</h3> 
      <vs-pagination :total="total_pages" v-model="currentx" goto></vs-pagination>
      <template v-for="(unmatched_account, key) in unmatch_accounts">
       
        <vs-table stripe :data="unmatched_account" class="mb-20">
          <template slot="header">

        <vs-row vs-w="12" class="mb-5">
          <vs-col vs-lg="4" vs-sm="4" vs-xs="12">
          </vs-col>
          <vs-col vs-lg="4" vs-sm="4" vs-xs="12">
            <BuildAutocomplete :unmatched_account="unmatched_account" @update-accepted-id="acceptedIds"
                @update-rejected-id="rejectedIds" :selectedSlave="unmatched_account.id" :campaignId="campaignId"
                class="searchbox" :key="componentKey" :combined_matches="combined_matches"></BuildAutocomplete>
          </vs-col>
        

         

          


         <vs-col vs-lg="4" vs-sm="4" vs-xs="12">
          </vs-col>
        </vs-row>
           
            <div class="center">


              <!-- <span>Search : {{unmatched_account}}</span> -->
             
            </div>

            <!-- <input
            type="checkbox"
            v-model="selected"
            @click="select"
           :value="{ id: unmatched_account.id}"
          /> -->
          </template>

          <template slot="thead">
            <!-- <vs-th>
              Action
            </vs-th> -->
            <template v-for="(uploadedcol, index) in Object.keys(unmatched_account)">
              <vs-th>
                <template v-if="unmatched_account[uploadedcol]">


                  {{ uploadedcol }}
                </template>
              </vs-th>
            </template>
          </template>

          <template slot-scope="{ data }">
            <vs-tr>
              <!-- <div class="p-5">
                <vs-button @click="writeMasterDatabaseAndMatch(unmatched_account)" type="border">Write</vs-button>
              </div>
              <div class="m-5">

                <vs-button @click="dropAccountsFromCampaign(unmatched_account)" type="border"> Drop </vs-button>
              </div> -->
              <template v-for="(value, index) in Object.values(unmatched_account)">
                
                <vs-td>
                  <template v-if="value">
                    {{ value }}
                  </template>
                </vs-td>
              </template>
            </vs-tr>
          </template>
        </vs-table>
      </template>
      <vs-pagination :total="total_pages" v-model="currentx" goto></vs-pagination>
    </vx-card>


    <vs-popup fullscreen class="holamundo" title="Add Unmatched Account To Master DB And Add To Campaign"
      :active.sync="addNewAccountsPopUp">


      <template v-for="(value,key) in selected_unmatched_account">
        


        <template v-for="field_array_column in  field_array_columns">
           <template v-if="field_array_column.name == key">


            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span
                  :class="{ 'correction_field_class': correction_fields_array.includes(field_array_column.name) }">{{ key }} </span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <div class="vx-col sm:w-2/3 w-full">


                 <template v-if="field_array_column.identifier == 'registered_office_country'">

                  <v-select name="registered_office_country" class="registered_office_country" label="name_1"
                  :options="all_countries" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="selected_unmatched_account[key]" />
                 </template>

                 <template v-else-if="field_array_column.identifier == 'head_office_country'">
                  <v-select name="head_office_country" class="head_office_country" label="name_1"
                  :options="all_countries" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="selected_unmatched_account[key]" />
                
                </template>

                <template v-else-if="field_array_column.identifier == 'registration_jurisdiction'">
                  <v-select name="registration_jurisdiction" class="registration_jurisdiction" label="name_1"
                  :options="all_countries" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="selected_unmatched_account[key]" />
                
                </template>



                <template v-else-if="field_array_column.identifier == 'phone_type'">
                  <div class="vx-col sm:w-1/3 w-full">
                    <v-select :class="{ 'correction_field_input_class': correction_fields_array.includes('phone_type') }"
                      label="name" :options="phoneTypes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="selected_unmatched_account[key]" />
                  </div>
                </template>

                

                <template v-else-if="field_array_column.identifier == 'phone_code'">

                  <div class="vx-col sm:w-1/3 w-full">
                    <v-select :class="{ 'correction_field_input_class': correction_fields_array.includes('phone_code') }"
                      label="phone_code" :options="all_phone_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="selected_unmatched_account[key]" />
                  </div>
                </template>


                <template v-else-if="field_array_column.identifier == 'switchboard_phone_code'">
            
                  <div class="vx-col sm:w-1/3 w-full">
                    <v-select :class="{ 'correction_field_input_class': correction_fields_array.includes('switchboard_phone_code') }"
                      label="phone_code" :options="all_phone_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="selected_unmatched_account[key]" />
                  </div>
                </template>

                <template v-else-if="field_array_column.identifier == 'sic_code'">
                  <div class="vx-col sm:w-1/3 w-full">

                    <v-select :class="{ 'correction_field_input_class': correction_fields_array.includes('sic_code') }"
                    label="code" :options="all_sic_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="selected_unmatched_account[key]" />
                </div>
                   
                </template>

                <template v-else-if="field_array_column.identifier == 'vertical'">
                  <div class="vx-col sm:w-1/3 w-full">

                    <v-select :class="{ 'correction_field_input_class': correction_fields_array.includes('vertical') }"
                    label="vertical" :options="all_verticals" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="selected_unmatched_account[key]" />
                </div>
                   
                </template>

                <template v-else-if="field_array_column.identifier == 'currency_code'">
                  <div class="vx-col sm:w-1/3 w-full">

                    <v-select :class="{ 'correction_field_input_class': correction_fields_array.includes('currency_code') }"
                    label="code" :options="all_currency_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="selected_unmatched_account[key]" />
                </div>
                   
                </template>
                



                <template v-else>

                  <template v-if="field_array_column.type == 'date'">

<template v-if="correction_fields_array.includes(field_array_column.name)">
                      {{ selected_unmatched_account[key] }}
                      <br>
                      </template>
      
                                <flat-pickr
                                :class="{ 'correction_field_input_class': correction_fields_array.includes(field_array_column.name) }"
                                  :config="configDatePicker"
                                  placeholder="Choose Date"
                                  :data-vv-as="field_array_column.name"
                                  :name="field_array_column.name" v-validate="field_array_column.mandatory?'required':''"
                                  v-model="selected_unmatched_account[key]"
                                />
                                  <span class="text-danger text-sm" v-show="errors.has(field_array_column.name)">{{
                    errors.first(field_array_column.name) }}</span>
                              </template>

                                <template v-else-if="field_array_column.type == 'datetime'">

<template v-if="correction_fields_array.includes(field_array_column.name)">
                      {{ selected_unmatched_account[key] }}
                      <br>
                      </template>
      
                                <flat-pickr
                                :class="{ 'correction_field_input_class': correction_fields_array.includes(field_array_column.name) }"
                                  :config="configDateAndTimePicker"
                                  :data-vv-as="field_array_column.name"
                                  placeholder="Choose Date And Time"
                                  :name="field_array_column.name" v-validate="field_array_column.mandatory?'required':''"
                                  v-model="selected_unmatched_account[key]"
                                />
                                  <span class="text-danger text-sm" v-show="errors.has(field_array_column.name)">{{
                    errors.first(field_array_column.name) }}</span>
                              </template>

                                  <template v-else-if="field_array_column.type == 'number'">

                                    {{ correction_fields_array.includes(field_array_column.name) ? selected_unmatched_account[key] : '' }}


                                    <input type="number" 
                                    class="vs-input-class"
                            :class="{ 'correction_field_input_class': correction_fields_array.includes(field_array_column.name) }"
                                    v-model="selected_unmatched_account[key]" :name="field_array_column.name" v-validate="field_array_column.mandatory?'required':''"
                             :data-vv-as="field_array_column.name" />
      
                             
                                  <span class="text-danger text-sm" v-show="errors.has(field_array_column.name)">{{
                    errors.first(field_array_column.name) }}</span>
                              </template>


                                



 <template v-else>

                <vs-input
                  :class="{ 'correction_field_input_class': correction_fields_array.includes(field_array_column.name) }"
                  class="w-full" v-model="selected_unmatched_account[key]" :name="field_array_column.name" v-validate="field_array_column.mandatory?'required':''"
                   :data-vv-as="field_array_column.name" />
                   <span class="text-danger text-sm" v-show="errors.has(field_array_column.name)">{{
                    errors.first(field_array_column.name) }}</span> 
             
       </template>
             </template>
                  </div>
      </div>
            </div>
           </template>


        </template>








      </template>






    

      <div class="vx-row">
        <div class="vx-col sm:w-2/3 w-full ml-auto">
          <vs-button @click="submitUpdate()" class="mr-3 mb-2">Submit</vs-button>
        </div>
      </div>
    </vs-popup>



    <template v-if="accountExists">
      <vs-popup fullscreen :title="accountDescription.company_name" :active.sync="popupActive">
        <div class="flex justify-between flex-wrap">
          <vs-button class="mb-4 mr-6" @click="accept()" type="border">Accept</vs-button>
          <vs-button class="mb-4" type="border" @click="reject()" color="primary">Reject</vs-button>
        </div>
        <vs-list>
          <vs-list-header title="Key Company Details" color="success"></vs-list-header>
          <vs-list-item title="Company Name ">
            {{ accountDescription.company_name }}
          </vs-list-item>
          <vs-list-item title="Company Registration Number">
            {{ accountDescription.company_registration_number }}
          </vs-list-item>
          <vs-list-item title="Switchboard">
            <template v-for="(ph, index) in accountDescription.phone">
              <div :key="index">
                <template v-for="(ph_type, index2) in ph.phone_type">
                  <div :key="index2" v-if="ph_type.type == 'Switchboard' && ph_type.phone_id == ph.id
                    ">
                    {{ ph.phone_no }}
                  </div>
                </template>
              </div>
            </template>
          </vs-list-item>
          <vs-list-item title="Site Switchboard">
            <template v-for="(ph, index) in accountDescription.phone">
              <div :key="index">
                <template v-for="(ph_type, index2) in ph.phone_type">
                  <div :key="index2" v-if="ph_type.type == 'Site Switchboard' &&
                    ph_type.phone_id == ph.id
                    ">
                    {{ ph.phone_no }}
                  </div>
                </template>
              </div>
            </template>
          </vs-list-item>
        </vs-list>

        <vs-list>
          <vs-list-header title="Address" color="success"></vs-list-header>
          <vs-list-item title="Head Office Address">
            {{ accountDescription.head_office_address_1 }}
            {{ accountDescription.head_office_address_2 }}
            {{ accountDescription.head_office_address_3 }}
            {{ accountDescription.head_office_city }}
            {{ accountDescription.head_office_postcode }}
            {{ accountDescription.head_office_county }}
            {{ accountDescription.head_office_country }}
          </vs-list-item>
          <vs-list-item title="Registered Office Address">
            {{ accountDescription.registered_office_address_1 }}
            {{ accountDescription.registered_office_address_2 }}
            {{ accountDescription.registered_office_address_3 }}
            {{ accountDescription.registered_office_city }}
            {{ accountDescription.registered_office_postcode }}
            {{ accountDescription.registered_office_county }}
            {{ accountDescription.registered_office_country }}
          </vs-list-item>
          <template v-for="(satellite, index) in accountDescription.satellite_office">
            <vs-list-item :title="'Satellite Office ' + (index + 1)" :key="index">
              <template v-for="(phone, index3) in satellite.phone">
                <div :key="index3" v-if="phone.satellite_office_id == satellite.id">
                  {{ phone.phone_no }}
                </div>
              </template>
              {{ satellite.address_1 }}
              {{ satellite.address_2 }}
              {{ satellite.address_3 }}
              {{ satellite.town }}
              {{ satellite.county }}
              {{ satellite.postcode }}

              <template v-for="(country, index2) in satellite.country">
                <div :key="index2" v-if="country.satellite_office_id == satellite.id">
                  {{ country.name_1 }}
                  {{ country.name_2 }}
                  {{ country.name_3 }}
                </div>
              </template>
            </vs-list-item>
          </template>
        </vs-list>

        <vs-list>
          <vs-list-header title="Websites" color="success"></vs-list-header>
          <template v-for="(web, index) in accountDescription.web">
            <div :key="index">
              {{ web.url }}
            </div>
          </template>
        </vs-list>
        <vs-list>
          <vs-list-header title="LinkedIn" color="success"></vs-list-header>
          <template v-for="(linkedin, index) in accountDescription.linkedin">
            <div :key="index">
              {{ linkedin.url }}
            </div>
          </template>
        </vs-list>
      </vs-popup>
    </template>
  </div>
</template>

<script>
import moduleAccountsManagement from "@/store/accounts-management/moduleAccountsManagement.js";
import _ from "lodash";
import defineAbilitiesFor from "@/config/abilities";
import axios from "@/axios.js";
import moduleCampaignsManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import BuildAutocomplete from "@/components/autocomplete/BuildAutocomplete.vue";
import vSelect from "vue-select";
import ProgressBar from 'vue-simple-progress'
 import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";
    import "quill/dist/quill.core.css";
    import "quill/dist/quill.snow.css";
    import "quill/dist/quill.bubble.css";
export default {
  components: { BuildAutocomplete, "v-select": vSelect , ProgressBar ,             flatPickr
},
  computed: {
    total_pages () {
      console.log("totla" , this.all_total)
      return Math.ceil(this.all_total / this.limit);
    },
    // cloneItems() {
    //     var clone = this.unmatch_accounts;
    //     var startFrom = (this.pagination.page*this.pagination.rowsPerPage)-this.pagination.rowsPerPage;
    //     return clone.splice(startFrom, this.pagination.rowsPerPage);
    // }
  },
  data() {
    return {
                    configDatePicker: {
      enableTime: false,
      dateFormat: 'Y-m-d',
      allowInvalidPreload	: false,
    },
      configDateAndTimePicker: {
      enableTime: true,
      dateFormat: "Y-m-d H:i:s",
      allowInvalidPreload	: false,
      enableSeconds : true
    },
      PLeasewait: '',
      uploadPercentage: 0,
      all_unmatched_accounts : [],
      selected: [],
      allSelected: false,
      all_currency_codes : [],
      all_verticals : [],
      all_sic_codes : [],
      all_countries : [],
      selected_unmatched_account : {}, 
      mandatory_fields: [],
      all_phone_codes:[],
      selected_fields: null,
      phoneTypes: [],
      selected_registered_office_country: null,
      correction_fields_array: [],
      vertical: null,
      selected_vertical: null,
      correction_fields: null,
      selected_registration_jurisdiction: null,
      currencyCodes: [],
      selected_sic_code: null,
      add_or_update_title: null,
      user_id: null,
      user_role: null,
      selected_head_office_country: null,
      abilities: null,
      field_array_columns: [],
      actual_account_name:null,
      registered_office_address_1: null,
      registered_office_address_2: null,
      registered_office_address_3: null,
      registered_office_city: null,
      registered_office_county: null,
      registered_office_postcode: null,
      registered_office_country: null,
      head_office_address_1: null,
      head_office_address_2: null,
      head_office_address_3: null,
      head_office_city: null,
      head_office_county: null,
      head_office_postcode: null,
      company_category: null,
      sic_code: null,
      revenue: null,
      currency_code: null,
      registration_jurisdiction: null,
      no_of_employees: null,
      // sic_code_description: null,
      phone_type: null,
      phone_no: null,
      phone_code: null,
      website: null,
      linkedin: null,
      status: null,
      switchboard: null,
      switchboard_phone_code: null,
      site_switchboard: null,
      site_switchboard_phone_code: null,
      company_name: null,
      selected_fields: null,
      registered_office_country_validation: null,
      EnhancedHeadOfficeAutocompleteComponentKey: 0,
      EnhancedRegOfficeAutocompleteComponentKey: 0,
      EnhancedSicCodeAutocompleteComponentKey: 0,
      EnhancedVerticalAutocompleteComponentKey: 0,
      EnhancedRegistrationJurisdictionAutocompleteComponentKey: 0,
      company_registration_number: null,
      country: null,
      isNewAccount: null,
      update_id: null,
      table: null,
      popupActive: false,
      updateData: [],
      currency_code_validation: null,
      currencyCodes: [],
      abilities: null,
      showHeadOfficeCountryField: true,
      showEditAutocomplete: false,
      telephone_show_no: 5,
      linkedin_show_no: 5,
      website_show_no: 5,
      accountDescription: {},
      accountExists: false,
      websiteExists: false,
      linkedinExists: false,
      parent_name: null,
      RegistrationJurisdiction: null,
      verticalName: null,
      headOfficeIsRegisteredOffice: false,
      old_head_office_address_1: null,
      old_head_office_address_2: null,
      old_head_office_address_3: null,
      old_head_office_city: null,
      old_head_office_county: null,
      old_head_office_postcode: null,
      old_head_office_country: null,
      old_company_registration_number: null,
      accounts: {
        web: null,
        phone: null,
        linkedin: null,
        main_counter: 0,
        vertical: null,
        phoneTypes: [],
        phoneType: [],
        joinedPhoneAndTypes: [],
        joinedSicAndDescription: [],
        websites: [],
        linkedins: [],
        phoneWithTypes: [],
        sicCodeWithDescription: [],
        verticals: [],
        vertical: null,
        sic_code: null,
        sic_code_description: null,
        currency_code: null,
        revenue: null,
        no_of_employees: null
      },
      accountDescription: {},
      addNewAccountsPopUp: false,
      campaignDescription: [],
      export_link: null,
      enrich_account_to_master_db_link: null,
      abilities: null,
      campaignId: null,
      componentKey: 0,
      limit: 10,
      currentx: 1,
      paginate: { limit: 10, offset: 0 },
      tableData: [],
      header: [],
      sheetName: "",
      list2: [],
      uploaded_columns: [],
      selected_fields: [
        "ml_company",
        "ml_actual_account_name",
        [
          [
            "Head Office Address",
            "Registered Office",
            "State",
            "Town",
            "Country",
            "Postal Code",
            "Site Office"
          ]
        ]
      ],
      unmatch_accounts: [],
      accept_text: "Accept",
      acceptButtonColor: "primary",
      accepted_matches: [],
      combined_matches: [],
      all_total : 0
    };
  },
  mounted() {
    this.getSelectedMandatoryFields();
    this.getPhoneTypes();
    this.getCurrencyCodes();
    this.unmatchedData();
    this.getCampaignDescription();
    this.getAllPhoneCodes()
    this.getAllSicCodes()
    this.getAllVerticals()
    this.getAllCurrencyCodes()
    this.export_link = "/accounts/remain_unmatched/" + this.campaignId;
    this.enrich_account_to_master_db_link =
      "/accounts/enrichAccountDataToMasterDb/" + this.campaignId;
  },
  watch: {
    website_show_no(val) {
      if (val) {
        this.accountDescription.webShow = this.accountDescription.web.slice(
          0,
          val
        );
      }
    },
    linkedin_show_no(val) {
      if (val) {
        this.accountDescription.linkedinShow = this.accountDescription.linkedin.slice(
          0,
          val
        );
      }
    },
    telephone_show_no(val) {
      if (val) {
        this.accountDescription.phone = this.accountDescription.phone.slice(
          0,
          val
        );
      }
    },
    headOfficeIsRegisteredOffice(val) {
      if (val) {
        this.accountDescription.head_office_address_1 = this.accountDescription.registered_office_address_1;
        this.accountDescription.head_office_address_2 = this.accountDescription.registered_office_address_2;
        this.accountDescription.head_office_address_3 = this.accountDescription.registered_office_address_3;
        this.accountDescription.head_office_city = this.accountDescription.registered_office_city;
        this.accountDescription.head_office_county = this.accountDescription.registered_office_county;
        this.accountDescription.head_office_postcode = this.accountDescription.registered_office_postcode;
        this.accountDescription.head_office_country = this.accountDescription.registered_office_country;
      } else {
        this.accountDescription.head_office_address_1 = this.old_head_office_address_1;
        this.accountDescription.head_office_address_2 = this.old_head_office_address_2;
        this.accountDescription.head_office_address_3 = this.old_head_office_address_3;
        this.accountDescription.head_office_city = this.old_head_office_city;
        this.accountDescription.head_office_county = this.old_head_office_county;
        this.accountDescription.head_office_postcode = this.old_head_office_postcode;
        this.accountDescription.head_office_country = this.old_head_office_country;
      }
    },
    "accounts.websites"(val) {
      if (val) {
        var lastItem = val[val.length - 1];
        if (this.validDomain(lastItem)) {
          this.$store
            .dispatch("accountsManagement/checkWebsiteExists", lastItem)
            .then(res => {
              if (res.data.status == "fail") {
                this.websiteExists = true;
                this.$vs.dialog({
                  color: "primary",
                  title: `Confirm`,
                  text: "This website already exists.",
                  accept: (this.websiteExists = false)
                });
                var index = this.accounts.websites.indexOf(lastItem);
                this.accounts.websites.splice(index, 1);
              } else {
                return;
              }
            })
            .catch(err => {
              if (err.response.status === 401) {
                this.$router.replace("/login");
              }
            });
        } else {
          var index = this.accounts.websites.indexOf(lastItem);
          this.accounts.websites.splice(index, 1);
          return false;
        }
      }
    },
    "accounts.linkedins"(val) {
      if (val) {
        var lastItem = val[val.length - 1];
        if (this.validDomain(lastItem)) {
          this.$store
            .dispatch("accountsManagement/checkLinkedinExists", lastItem)
            .then(res => {
              if (res.data.status == "fail") {
                this.linkedinExists = true;
                this.$vs.dialog({
                  color: "primary",
                  title: `Confirm`,
                  text: "This linkedin already exists.",
                  accept: (this.linkedinExists = false)
                });
                var index = this.accounts.linkedins.indexOf(lastItem);
                this.accounts.linkedins.splice(index, 1);
              } else {
                return;
              }
            })
            .catch(err => {
              if (err.response.status === 401) {
                this.$router.replace("/login");
              }
            });
        } else {
          var index = this.accounts.linkedins.indexOf(lastItem);
          this.accounts.linkedins.splice(index, 1);
          return false;
        }
      }
    },
    currentx: function (val, oldVal) {


  


      this.unmatch_accounts = this.all_unmatched_accounts.slice((val - 1) *  this.limit, val * this.limit);
    }
  },
  methods: {
    removeDuplicates(myArr, prop) {
      return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
      });
    },
    selectAll() {

    


// this.$vs.loading();






// let matches = this.unmatch_accounts;



var matches = [...this.unmatch_accounts, ...this.all_unmatched_accounts];



if (this.allSelected) {
  matches.forEach(match => {
    this.selected.pop({ id: match.id});
  });
} else {

  

  
  // this.allSelected = false;
  matches.forEach(match => {
    this.selected.push({ id: match.id });
  });
  // this.match_ten_context.map(
  //   function(ele) {
  //     if (ele.page == this.currentx) {
  //       return (ele.ten_selected = true);
  //     }
  //   }.bind(this)
  // );
}

this.selected = this.removeDuplicates(this.selected, "id");


// this.$vs.loading.close();

},
select() {
this.allSelected = false;

// this.match_ten_context.map(
//   function(ele) {
//     if (ele.page == this.currentx) {
//       return (ele.ten_selected = false);
//     }
//   }.bind(this)
// );
},
    getSelectedMandatoryFields() {
      let self = this;
      let selected_campaign_id = self.$route.params.campaignId
      self.$store
        .dispatch(
          "campaignsManagement/getSelectedMandatoryFields",
          selected_campaign_id
        )
        .then(response => {
          let result = JSON.parse(response.data);

          if (result.length != 0) {


          self.mandatory_fields = result.filter(ele => ele.level == 'account' || ele.level == 'opportunity' );





          }

        })
        .catch(err => {
          if (err) {

            console.log(err)
            return;
          }
          console.error(err);
        });
    },
    campaignDataOptions(){




     let self  = this
   

        self.$router
              .push(
                "/accounts/optionsAfterImportAccountToCampaign/" +
                self.campaignId
              )
    


      // this.checkDuplicateExists();
    },
    getPhoneTypes() {
      this.$store
        .dispatch("accountsManagement/getPhoneTypes")
        .then(res => {
          this.accounts.phoneTypes = res.data;
          this.accounts.phoneTypes = this.accounts.phoneTypes.filter(
            item => item.name != "Site Switchboard"
          );
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getCountries(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getCountries", inputValue)
        .then(response => {
          let data = moduleAccountsManagement.state.countries;
          // console.log(data);
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].name_1
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    editHeadOfficeCountry() {
      this.showHeadOfficeCountryField = false;
      this.showEditAutocomplete = true;
      this.$refs.EditAutoComplete.$refs.suggestComponent.isInFocus = true;
      this.$refs.EditAutoComplete.$refs.suggestComponent.isClicking = true;
      this.$refs.EditAutoComplete.$refs.suggestComponent.input.value = this.accountDescription.head_office_country;
      this.$refs.EditAutoComplete.$refs.suggestComponent.value = this.accountDescription.head_office_country;
    },
    showGroupCompanies() {
      const parentId = this.accountDescription.parent;
      this.$store
        .dispatch("accountsManagement/getGroupCompanies", parentId)
        .then(res => {
          this.groupCompanies = res.data;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.groupCompanies = true;
            return;
          }
          console.error(err);
        });
    },
    getPhoneTypes() {
      this.$store
        .dispatch("accountsManagement/getPhoneTypes")
        .then(res => {
          this.phoneTypes = res.data;
          this.phoneTypes = this.phoneTypes.filter(
            item => item.name != "Site Switchboard"
          );
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getCurrencyCodes(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getCurrencyCodes")
        .then(response => {
          let response_data = response.data
          let mappedArray = [];
          for (const property in response_data) {
            mappedArray.push({
              id: response_data[property].id,
              label: response_data[property].symbol + ' ' + response_data[property].name + ' ' + response_data[property].code
            });
          }
          this.currencyCodes = mappedArray
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getCountries(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getCountries", inputValue)
        .then(response => {
          let data = moduleAccountsManagement.state.countries;
          // console.log(data);
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].name_1
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getAllSicCodes() {
     this.$store
        .dispatch("accountsManagement/getAllSicCodes")
        .then(response => {
          let data = response.data
          this.all_sic_codes = data
          // let mappedArray = [];
          // for (const property in data) {
          //   mappedArray.push({
          //     id: data[property].id,
          //     name: data[property].code + ' - ' + data[property].description
          //   });
          // }
          // return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getAllVerticals() {
     this.$store
        .dispatch("accountsManagement/getAllVerticals")
        .then(response => {
          let data = response.data
          this.all_verticals = data
          // let mappedArray = [];
          // for (const property in data) {
          //   mappedArray.push({
          //     id: data[property].id,
          //     name: data[property].code + ' - ' + data[property].description
          //   });
          // }
          // return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getAllCurrencyCodes() {
     this.$store
        .dispatch("accountsManagement/getAllCurrencyCodes")
        .then(response => {
          let data = response.data
          this.all_currency_codes = data
          // let mappedArray = [];
          // for (const property in data) {
          //   mappedArray.push({
          //     id: data[property].id,
          //     name: data[property].code + ' - ' + data[property].description
          //   });
          // }
          // return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getSicCodes(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getSicCodes", inputValue)
        .then(response => {
          let data = moduleAccountsManagement.state.sic_codes;
          // console.log(data);
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].code + ' - ' + data[property].description
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getVerticals(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getVerticals", inputValue)
        .then(response => {
          let data = moduleAccountsManagement.state.verticals;
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].vertical
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    showParentName(parentId) {
      this.$store
        .dispatch("accountsManagement/getParent", parentId)
        .then(res => {
          this.parent_name = res.data.company_name;
          // console.log(res.data)
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.parent_name = true;
            return;
          }
          console.error(err);
        });
    },
    showRegistrationJurisdiction(countryId) {
      this.$store
        .dispatch("accountsManagement/getCountry", countryId)
        .then(res => {
          this.RegistrationJurisdiction = res.data.name_1;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.accountDescription.parent = true;
            return;
          }
          console.error(err);
        });
    },
    showVertical(verticalId) {
      this.$store
        .dispatch("accountsManagement/getVertical", verticalId)
        .then(res => {
          this.verticalName = res.data.vertical;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    removeSelectedSiteAddress(site) {
      this.accountDescription.satellite_office = this.accountDescription.satellite_office.filter(
        item => {
          return item.counter != site.counter;
        }
      );
    },
    getAllPhoneCodes() {
      let self = this
      this.$store
        .dispatch("accountsManagement/getAllPhoneCodes")
        .then(response => {
          self.all_phone_codes = response.data
          self.all_countries = response.data
          self.all_phone_codes.forEach(function(ele){
            if(ele.phone_code){
              ele.name_with_code = ele.phone_code + ' - ' + ele.name_1
            }
            return ele
          })

          
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    addSiteOffice() {
      this.accountDescription.satellite_office.push({
        counter: ++this.accounts.main_counter,
        address_1: null,
        address_2: null,
        address_3: null,
        city: null,
        county: null,
        postcode: null,
        country: null,
        phone: null
      });
      // console.log(this.accounts.main_counter);
      // console.log(this.accounts.satellite);
    },
    removeSelectedWeb(url) {
      this.accountDescription.web = this.accountDescription.web.filter(item => {
        return item != url;
      });
    },
    removeSelectedLinkedin(url) {
      this.accountDescription.linkedin = this.accountDescription.linkedin.filter(
        item => {
          return item != url;
        }
      );
    },
    removeSelectedPhone(phone) {
      this.accountDescription.phone = this.accountDescription.phone.filter(
        item => {
          return item != phone;
        }
      );
      this.accountDescription.phone = this.accountDescription.phone;
    },
    removeSelectedSicCode(sic_code) {
      this.accountDescription.sic_code = this.accountDescription.sic_code.filter(
        item => {
          return item != sic_code;
        }
      );
      this.accountDescription.phone = this.accountDescription.phone;
    },
    removeNewSelectedSicCode(selected) {
      this.accounts.joinedSicAndDescription = this.accounts.joinedSicAndDescription.filter(
        item => {
          return item != selected;
        }
      );
    },
    removeNewSelectedPhone(selected) {
      console.log(selected);
      this.accounts.joinedPhoneAndTypes = this.accounts.joinedPhoneAndTypes.filter(
        item => {
          return item != selected;
        }
      );
    },
    validDomain(userInput) {
      if (userInput) {
        var res = userInput.match(
          /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
        );
        if (res == null) {
          return false;
        }
      }
      return true;
    },
    addPhoneNumbers() {
      if (
        this.accounts.phone &&
        this.accounts.phoneType &&
        !this.accounts.joinedPhoneAndTypes.includes(
          this.accounts.phoneType.name + " - " + this.accounts.phone
        )
      )
        this.accounts.joinedPhoneAndTypes.push(
          this.accounts.phoneType.name + " - " + this.accounts.phone
        );
      let mappedPhoneTypes = {};
      mappedPhoneTypes.phone_no = this.accounts.phone;
      mappedPhoneTypes.phone_type = this.accounts.phoneType.slug;
      this.accounts.phoneWithTypes.push(mappedPhoneTypes);
      this.accounts.phone = null;
      this.accounts.phoneType = null;
    },
    addSicCodes() {
      if (
        this.accounts.sic_code &&
        this.accounts.sic_code_description &&
        !this.accounts.joinedSicAndDescription.includes(
          this.accounts.sic_code + " - " + this.accounts.sic_code_description
        )
      )
        this.accounts.joinedSicAndDescription.push(
          this.accounts.sic_code + " - " + this.accounts.sic_code_description
        );

      let mappedSicDescription = {};
      mappedSicDescription.code = this.accounts.sic_code;
      mappedSicDescription.description = this.accounts.sic_code_description;
      this.accounts.sicCodeWithDescription.push(mappedSicDescription);
      this.accounts.sic_code = null;
      this.accounts.sic_code_description = null;
    },
    addWebsite() {
      if (
        this.accounts.web &&
        !this.accountDescription.web.includes(this.accounts.web)
      )
        this.accountDescription.web.push({ url: this.accounts.web });
      this.accounts.web = null;
    },
    addLinkedin() {
      if (
        this.accounts.linkedin &&
        !this.accountDescription.linkedin.includes(this.accounts.linkedin)
      )
        this.accountDescription.linkedin.push({ url: this.accounts.linkedin });
      this.accounts.linkedin = null;
    },
    updateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (moduleAccountsManagement.autocomplete_selected) {
            this.accountDescription.parent =
              moduleAccountsManagement.autocomplete_selected.id;
          }
          if (moduleAccountsManagement.vertical_selected) {
            this.accountDescription.vertical =
              moduleAccountsManagement.vertical_selected.id;
          }
          if (moduleAccountsManagement.countries_selected) {
            this.accountDescription.registration_jurisdiction =
              moduleAccountsManagement.countries_selected.id;
          }
          if (moduleAccountsManagement.head_office_country_selected) {
            this.accountDescription.head_office_country =
              moduleAccountsManagement.head_office_country_selected.name;
          }
          this.accountDescription.id = this.$route.params.accountId;

          this.accountDescription.phoneWithTypes = [];
          this.accountDescription.phone.map(phone_ele => {
            phone_ele.phone_type.map(phone_type_ele => {
              if (phone_type_ele.phone_id == phone_ele.id) {
                console.log(phone_type_ele);
                let mappedPhoneTypes = {};
                mappedPhoneTypes.phone_no = phone_ele.phone_no;
                mappedPhoneTypes.phone_type = phone_type_ele.type;
                this.accountDescription.phoneWithTypes.push(mappedPhoneTypes);
              }
            });
          });
          this.accountDescription.phoneWithTypes = _.unionBy(
            this.accountDescription.phoneWithTypes,
            this.accounts.phoneWithTypes,
            "phone_no"
          );

          this.accountDescription.sicCodeWithDescription = [];
          this.accountDescription.sic_code.map(sic_ele => {
            let mappedPhoneTypes = {};
            mappedPhoneTypes.code = sic_ele.code;
            mappedPhoneTypes.description = sic_ele.description;
            this.accountDescription.sicCodeWithDescription.push(
              mappedPhoneTypes
            );
          });
          this.accountDescription.sicCodeWithDescription = _.unionBy(
            this.accountDescription.sicCodeWithDescription,
            this.accounts.sicCodeWithDescription,
            "code"
          );

          if (
            this.accountDescription.revenue != null &&
            this.accountDescription.currency_code == null
          ) {
            this.currency_code_validation =
              "The currency code field is required";
            return false;
          }
          this.addAccountAndAddToCampaign();
          // if form have no errors
        } else {
          // form have errors
        }
      });
    },
    submitUpdate() {


      this.$validator.validateAll().then(result => {
        if (result) {


          this.selected_unmatched_account.campaignId = this.$route.params.campaignId;
          this.selected_unmatched_account.is_new_account = "Y"

          this.$store
            .dispatch(
              "accountsManagement/addAccountAndAddToCampaign",
              this.selected_unmatched_account
            )
            .then(response => {

              this.addNewAccountsPopUp = false;


              if (response.data == "company_registration_number_exists") {

                this.$vs.dialog({
                  color: "primary",
                  title: `Duplicate Company Registration Number`,
                  text:
                    "Company registration number already exists in the database.Please update it and submit again",
                  accept: this.addNewAccountsPopUp
                });
               }
               else if (response.data == "registration_number_and_registered_country_required") {

                this.$vs.dialog({
                  color: "primary",
                  title: `Required Fields`,
                  text:
                    "Company registration number and registered country is required",
                  accept: this.addNewAccountsPopUp
                });
                }
               else if (response.data == "required_correction") {
                this.$vs.dialog({
                  color: "primary",
                  title: `Required Correction`,
                  text:
                    "The fields with red title should be corrected. Please update it and submit again",
                  accept: this.addNewAccountsPopUp
                });
               }
                  else if (response.data == "registration_number_and_registered_country_required") {

                this.$vs.dialog({
                  color: "primary",
                  title: `Required Fields`,
                  text:
                    "Company registration number and registered country is required",
                  accept: this.addNewAccountsPopUp
                });
                }
                else if (response.data == "error") {

 this.$vs.notify({
                  color: "danger",
                  title: "Account Not Added",
                  text: "Something went wrong. Please contact administrator"
                });


}
              
              
              else {

                this.$vs.notify({
                  color: "success",
                  title: "Account Added",
                  text: "The account was added successfully"
                });


              }




              this.unmatchedData()
              this.$router.go(0);



            })
            .catch(error => {
              console.log(error);
            });
        }

      })



    },

    acceptAlert() {
      this.addNewAccountsPopUp = true;




    },
    addAccountAndAddToCampaign() {
      this.$store
        .dispatch(
          "accountsManagement/addAccountAndAddToCampaign",
          this.accountDescription
        )
        .then(res => {
          if (res.data.status == "fail") {
            this.addNewAccountsPopUp = false;

            this.$vs.notify({
              color: "success",
              title: "Account Exists",
              text: res.data.message
            });
            this.addNewAccountsPopUp = true;

            // return false
          } else {
            this.$vs.notify({
              color: "success",
              title: "Account Added",
              text: "The account was added successfully"
            });
            this.unmatchedData();
            this.addNewAccountsPopUp = false;
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    writeMasterDatabaseAndMatch(data) {
      this.correction_fields_array = []
      this.isNewAccount = "Y";
      this.add_or_update_title = "Please update the field and submit"
     

      if (data.correction_fields != null && data.correction_fields != '') {
        this.correction_fields_array = JSON.parse(data.correction_fields)
      }

      this.selected_unmatched_account = data;
      this.selected_unmatched_account.id = data.id


      this.addNewAccountsPopUp = true;
    },
    dropAccountsFromCampaign(data) {
      this.accountDescription = data;
      this.accountDescription.campaignId = this.$route.params.campaignId;
      this.$store
        .dispatch(
          "accountsManagement/dropAccountsFromCampaign",
          this.accountDescription
        )
        .then(res => {
          if (res) {
            this.$vs.notify({
              color: "success",
              title: "Account",
              text: "The account was removed successfully"
            });
            this.unmatchedData();
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    forceRerender() {
      this.componentKey += 1;
    },
    getCampaignDescription() {
      const campaignId = this.$route.params.campaignId;
      this.$store
        .dispatch("campaignsManagement/fetchCampaign", campaignId)
        .then(res => {
          this.campaignDescription = res.data;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = true;
            return;
          }
          console.error(err);
        });
    },
    acceptedIds(ids) {
      let self = this;
      self.$vs.loading();

      ids.forEach(function (ie) {
        self.combined_matches.push(ie);
        self.combined_matches.map(function (ce) {
          if (ie.slave_id == ce.slave_id) {
            return (ce.uuid = ie.master_id);
          }
        });
        self.combined_matches = self.combined_matches.filter(
          (v, i, a) => a.findIndex(t => t.slave_id === v.slave_id) === i
        );
      });


      self.combined_matches = self.combined_matches.map(function (ele) {
        ele.campaignId = self.campaignId;
        ele.user_id = self.user_id
        return ele;
      });



      axios
        .post(
          this.$base_url + "/api/accounts/save_data_build_matched_account",
          self.combined_matches
        )
        .then(response => {

          if (response.data.status == "success") {
            self.$vs.notify({
              color: "success",
              title: "Account Matched",
              text: "The account was matched successfully"
            });

            self.componentKey += 1;

          }
          self.unmatchedData()
          location.reload()

          console.log(response.data)

        })
        .catch(error => {
          console.log(error);
        });


        self.$vs.loading.close();







    },
    rejectedIds(ids) {
      let self = this;
      self.combined_matches = self.combined_matches.filter(function (ele) {
        return ele.slave_id != ids[0].slave_id;
      });
    },
    goBack: function () {
      this.$router.go(-1);
    },
    proceedToNextStep() {

      let self = this
      
        self.$router
              .push(
                "/accounts/associate_data_build_unmatched/" +
                self.$route.params.campaignId
              )
    },
 
    updateMasterdbFlag(){

      

        let self = this

          self.$vs.notify({
          color: "primary",
          title: "Update Master DB",
          text: "Please wait while the master db is being updated with matched excel accounts.This may take a few minutes",
        });

        self.$vs.loading()



      let data = {}
            data.campaignId = self.$route.params.campaignId;
            axios
              .post(
                self.$base_url + "/api/accounts/update_master_db_flag",
                data
              )
              .then(response => {
                if (response.data.status == "success") {
                  // console.log("Master DB Flag Updated Successfully");
                  self.$vs.loading.close();

                  self.$router
                    .push(
                      "/accounts/enrichAccountDataToMasterDb/" +
                      self.$route.params.campaignId
                    )
             


                  


                } else {
                  self.$vs.notify({
                    color: "danger",
                    title: "Error",
                    text: "Something went wrong. Please try again"
                  });
                }






                
                
              
              })
              .catch(error => {
                console.log(error);
              });

              self.$vs.loading.close();



    },
    writeSelectedAccountToMasterDB() {


      
      let self = this
       this.PLeasewait = "Please wait while the data is being written to the master database.This may take a few minutes"
      this.selected = this.removeDuplicates(this.selected, "id");



      let selected_data = {};
      selected_data.selected_accounts = this.selected;
      selected_data.campaignId =  this.$route.params.campaignId


    



      axios
        .post(
          this.$base_url + "/api/matched_accounts/write_selected_account_to_masterdb",
          selected_data, 
          {
            onDownloadProgress: function( progressEvent ) {

  
              let progress = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ) );
              
  
              if( progress == 100 ) {
                this.uploadPercentage = 100

                              }
                  
                  
                        }.bind(this),
                        onUploadProgress: function( progressEvent ) {

                  
                    
                          let progress = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ) );


                if( progress == 100 ) {
                  this.uploadPercentage = 50

                }


                }.bind(this)
          }).then(response => {
            


          
          let no_of_issues = response.data.data.no_of_issues
          let no_of_added_account = response.data.data.no_of_added_account
          

          if (response.data.status == "success") {

            self.$vs.loading.close();


            if (no_of_issues == 0) {


              self.$router
              .push(
                "/accounts/associate_data_build_unmatched/" +
                self.$route.params.campaignId
              )
              
            } else {
              this.$vs.dialog({
              color: "primary",
              title: `Import Account To Campaign`,
              text: no_of_added_account + " accounts were successfully added to the campaign.  However, " + no_of_issues + " selected accounts have issues.  Please resolve these before proceeding.",
              accept: this.finished,
            });
            }


            


           
          }
      
          // self.unmatchedData()


          
        })
        .catch(error => {
          console.log(error);
        });
    },
    finished() {
      this.selected = []
      this.allSelected = false
      location.reload()

      
      // this.unmatchedData()

    },
    // checkDuplicateExists() {
    //   let self = this;
    //   self.paginate.campaignId = self.campaignId;
    //   axios
    //     .post(
    //       this.$base_url + "/api/accounts/deduplicate_csv_accounts_data",
    //       self.paginate
    //     )
    //     .then(response => {
    //       let result = JSON.parse(response.data);

    //       if (result.length == 0) {

    //         self.$router
    //           .push(
    //             "/accounts/optionsAfterImportAccountToCampaign/" +
    //             self.campaignId
    //           )
    //           .catch(() => { });
    //           this.$vs.loading.close();

           
    //       } else {
    //         this.deduplicateOldNewCSV();
    //       }
    //     })
    //     .catch(error => {
    //       console.log(error);
    //     });
    // },
    updateOtherFieldDataToMasterDb() {
    let self = this

    self.$vs.dialog({
        color: "primary",
        title: `Import None Core Fields`,
        text: "You are about to import non-core fields to the database.  After you click accept this process will start.  You will receive an email once this process has completed. ",
        accept: this.acceptAlert
      });
    },
    acceptAlert() {
      let self = this
      let data = {};
      data.campaign_id = this.campaignId;
      axios
        .post(
          this.$base_url + "/api/accounts/update_other_field_to_masterdb_from_csv_table",
          data
        )
        .then(response => {
          if (response.data.status == "success") {


         self.sendCompletedEmail()
            

          

            console.log("Updated other field data to master db")
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    sendCompletedEmail(){
       let self = this
        let data = {}
        data.user_id = self.user_id
        data.message = "Import None Core Fields has been completed."
        data.subject = "Import None Core Fields"
        axios
        .post(
          self.$base_url + "/api/accounts/send_completed_email",
          data
        )
        .then(response => {
          if (response.data.status == "success") {
            self.$vs.notify({
              color: "success",
              title: "Import None Core Fields",
              text: "The email has been sent"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
        
    },
    deduplicateOldNewCSV() {
      let data = {};
      data.campaignId = this.campaignId;
      axios
        .post(
          this.$base_url + "/api/accounts/deduplicate_old_new_csv_account_data",
          data
        )
        .then(response => {
          if (response.data.status == "success") {
            this.$router.replace(
              "/accounts/deduplicateOldAndNewAccountCSVData/" + this.campaignId
            );
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    ucFirstAllWords(str) {
      var pieces = str.split(" ");
      for (var i = 0; i < pieces.length; i++) {
        var j = pieces[i].charAt(0).toUpperCase();
        pieces[i] = j + pieces[i].substr(1);
      }
      return pieces.join(" ");
    },
    formatUploadedHeader(s) {
      if (typeof s !== "string") return "";
      if (s.startsWith("ml_")) return "";
      // s = s.replace("_", " ");
      // s = s.replace("_", " ");
      // s = s.replace("_", " ");
      // s = s.replace("slave", " ");
      // s = s.replace("ml", " ");
      return s;
    },
    unmatchedData() {
      let self = this
      this.$vs.loading();
      let data = {};
      data.campaignId = this.campaignId;
      axios
        .post(
          this.$base_url + "/api/unmatched_accounts/data_build_unmatched",
          data
        )
        .then(response => {
          let response_data = JSON.parse(response.data)

          if (response_data.rows.length == 0) {

            self.$router
              .push(
                "/accounts/associate_data_build_unmatched/" +
                self.$route.params.campaignId
              )


           


           
          }else{

              this.unmatch_accounts = response_data.rows.slice((this.currentx - 1) *  this.limit, this.currentx * this.limit);


          this.all_unmatched_accounts = response_data.rows


          let total = response_data.total_pages;
          this.all_total = total;





          this.field_array_columns =response_data.campaign_table_data

          this.field_array_columns.forEach(function(ele){
            ele.mandatory = false

            self.mandatory_fields.forEach(function(mandatory){


              if(ele.name == mandatory.name){
                ele.mandatory = true
              }

            })

          })

          }






        



          // this.table = response_data.campaign_table_data[0]['table_name'];
          self.$vs.loading.close();
        })
        .catch(error => {
          console.log(error);
        });
    },
    getParentCompany(inputValue) {
      return this.$store
        .dispatch("accountsManagement/searchAutocomplete", inputValue)
        .then(response => {
          let data = JSON.parse(JSON.parse(JSON.stringify(response.data)));
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].uuid,
              name: data[property].company_name
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    }
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule(
        "accountsManagement",
        moduleAccountsManagement
      );
      moduleAccountsManagement.isRegistered = true;
    }
    if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignsManagement
      );
      moduleCampaignsManagement.isRegistered = true;
    }
    this.campaignId = this.$route.params.campaignId;
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.searchbox {
  padding: 10px 21px;
  width: 600px;
}

.relative {
  /* position: fixed !important; */
  z-index: 999;
  /* width: 98.5%; */
}

.vxtable {
  /* position: absolute !important; */
  margin-top: 20px;
}

.correction_field_class {
  color: red;
}

.correction_field_input_class {
  border: 1px solid red;
}

  .vs-input-class{
        width: 100%;
        border: 1px solid rgba(0, 0, 0, 0.2);
        font-size: 1rem;
        height: 38px;
        padding-left: 10px;
        padding-right: -10px;
        border-radius: 4px;
        background: transparent;
        transition: all .2s ease;
      
      
      }
</style>
